import addParam from '../addParam'

/**
 * QQ互联登录态
 * http://wiki.connect.qq.com/
 * @param opt.openid qq号
 * @param opt.accessToken 登录态的skey
 */
export default class {
  constructor(opt) {
    if (!opt.openid || !opt.accessToken && !opt.payToken) {
      console.error("session.qqconnect need openid,accessToken|payToken params");
    }

    this.qq_appid = opt.qq_appid || '';

    /**
		 * openid
		 */
    this.openid = opt.openid;
		/**
		 * accessToken
		 */
    this.accessToken = opt.accessToken;
		/**
		 * payToken
		 */
    this.payToken = opt.payToken;

  }

  getSessionParam() {
    if (this.payToken) {
      return {
        openid: encodeURIComponent(this.openid),
        openkey: encodeURIComponent(this.payToken),
        session_id: 'openid',
        session_type: 'kp_actoken',
        qq_appid: this.qq_appid
      };
    } else if (this.accessToken) {
      return {
        openid: encodeURIComponent(this.openid),
        openkey: encodeURIComponent(this.accessToken),
        session_id: 'openid',
        session_type: 'kp_accesstoken',
        qq_appid: this.qq_appid
      };
    }
  }

  addSessionParam(url) {
    if (this.payToken) {
      return addParam({
        openid: encodeURIComponent(this.openid),
        openkey: encodeURIComponent(this.payToken),
        sessionid: 'openid',
        sessiontype: 'kp_actoken'
      }, url);
    } else if (this.accessToken) {
      return addParam({
        openid: encodeURIComponent(this.openid),
        openkey: encodeURIComponent(this.accessToken),
        sessionid: 'openid',
        sessiontype: 'kp_accesstoken'
      }, url);
    }
  }
}
